import PosthogService from '~/services/posthog/PosthogService';

export interface IEndOfDayBlockPopupViewedPayload {
  shiftId: string;
  professionalId?: string;
}

/**
 * Fires when the block confirmation pop-up appears within the end-of-day flow.
 * Event: dental_portal:end_of_day:block_popup_viewed
 */
export function fireEndOfDayBlockPopupViewed(payload: IEndOfDayBlockPopupViewedPayload): void {
  PosthogService.getInstance().track('dental_portal:end_of_day:block_popup_viewed', {
    shift_id: payload.shiftId,
    professional_id: payload.professionalId,
  });
}
